export class Tag
{
    tagId: number;
}
